export default __webpack_public_path__ + "static/media/logo.b5ca72fb.svg";